/* Single – +/− steppers voor hoeveelheid (alleen hoofdformulier) */
import { updateTotal } from './priceTotal.js';

function getMainForm() {
  return (
    document.querySelector('.single-product form.variations_form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.variations_form.cart') ||
    document.querySelector('.single-product form.cart')
  );
}

export function mount() {
  const mainForm = getMainForm();
  if (!mainForm) return;

  mainForm.querySelectorAll('.quantity').forEach((qty) => {
    const input = qty.querySelector('input.qty');
    if (!input || qty.querySelector('.qty-btn')) return;

    const minus = Object.assign(document.createElement('button'), {
      type: 'button',
      className: 'qty-btn',
      textContent: '−'
    });
    minus.setAttribute('aria-label', 'Minder');

    const plus = Object.assign(document.createElement('button'), {
      type: 'button',
      className: 'qty-btn',
      textContent: '+'
    });
    plus.setAttribute('aria-label', 'Meer');

    qty.prepend(minus);
    qty.append(plus);

    const getNum = (el, attr, fallback) => {
      const n = Number(el.getAttribute(attr));
      return Number.isFinite(n) ? n : fallback;
    };

    qty.addEventListener('click', (e) => {
      if (!e.target.classList.contains('qty-btn')) return;

      const step = getNum(input, 'step', 1);
      const min = getNum(input, 'min', 1);
      const maxA = input.getAttribute('max');
      const max = maxA ? Number(maxA) : Infinity;

      let val = Number(input.value || min);
      val += e.target === plus ? step : -step;
      val = Math.max(min, Math.min(max, val));

      input.value = String(val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateTotal(input.closest('form'));
    });
  });
}
